<template>
  <div class="custom-charge-input">
    <div class="row">
      <label class="offset-sm-4 col-sm-8">{{ options.label }}</label>
    </div>
    <text-input ref="textInput"
      :options="{
        label: 'Description',
        required: options.required,
        maxLength: descriptionMaxLength
      }"
      @input="validate()"
      v-model="value.descriptionValue"></text-input>
    <currency-input ref="currencyInput"
      :options="{ label: 'Amount', required: options.required, minValue: minValue }"
      @input="validate()"
      v-model="value.amountValue"></currency-input>
  </div>
</template>

<script>
import TextInput from '@/components/inputs/TextInput'
import CurrencyInput from '@/components/inputs/CurrencyInput'

export default {
  name: 'CustomChargeInput',
  components: {
    TextInput,
    CurrencyInput
  },
  props: {
    value: {
      type: Object,
      default () {
        return {
          descriptionValue: '',
          amountValue: 0
        }
      }
    },
    options: {
      type: Object,
      default () {
        return {
          descriptionMaxLength: 128
        }
      }
    }
  },
  data () {
    return {
      isLength: true,
      isValid: false,
      isDirty: false,
      minLength: 1,
      descriptionMaxLength: 128,
      minValue: 0
    }
  },
  mounted () {
    if (this.options.descriptionMaxLength) {
      this.descriptionMaxLength = this.options.descriptionMaxLength
    }
    if (this.options.minValue) {
      this.minValue = this.options.minValue
    }
    this.validate()
    this.isDirty = false
    this.$refs.textInput.isDirty = false
    this.$refs.currencyInput.isDirty = false
  },
  methods: {
    async validateInput (input) {
      if (!input) {
        for (let child of this.$children) {
          child.isDirty = true
        }
      } else {
        this.$refs[input].isDirty = true
      }
      let val = {
        descriptionValue: this.value.descriptionValue,
        amountValue: this.value.amountValue
      }
      await this.$nextTick()
      this.isValid = this.$refs.textInput.isValid && this.$refs.currencyInput.isValid
      this.$emit('input', val)
    },
    validate () {
      this.isDirty = true
      this.validateInput()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CustomChargeInput.vue